import { OrderClassEnum } from '@modules/orders-module/enums/order-class.enum'
import { OrderHintsInterface } from '@modules/stocks-module/orders/interfaces/order-hints.interface'

export const OrderHints: OrderHintsInterface[] = [
	{
		title: 'ordersInfo.orderHints.bracket.main.title',
		helpText: 'ordersInfo.orderHints.bracket.main.helpText',
		orderClass: OrderClassEnum.BRACKET,
		isMain: true,
	},
	{
		title: 'ordersInfo.orderHints.bracket.secondary.0.title',
		helpText: 'ordersInfo.orderHints.bracket.secondary.0.helpText',
		orderClass: OrderClassEnum.BRACKET,
		isMain: false,
	},
	{
		title: 'ordersInfo.orderHints.bracket.secondary.1.title',
		helpText: 'ordersInfo.orderHints.bracket.secondary.1.helpText',
		orderClass: OrderClassEnum.BRACKET,
		isMain: false,
	},
	{
		title: 'ordersInfo.orderHints.oto.main.title',
		helpText: 'ordersInfo.orderHints.oto.main.helpText',
		orderClass: OrderClassEnum.OTO,
		isMain: true,
	},
	{
		title: 'ordersInfo.orderHints.oto.secondary.0.title',
		orderClass: OrderClassEnum.OTO,
		isMain: false,
	},
	{
		title: 'ordersInfo.orderHints.oco.main.title',
		helpText: 'ordersInfo.orderHints.oco.main.helpText',
		orderClass: OrderClassEnum.OCO,
		isMain: true,
	},
	{
		title: 'ordersInfo.orderHints.oco.secondary.0.title',
		helpText: 'ordersInfo.orderHints.oco.secondary.0.helpText',
		orderClass: OrderClassEnum.OCO,
		isMain: false,
	},
]
